export const TRAINING_WEEKS = 3;
export const HYPERCARE_DAYS = 3;

export const MANDATORY_COURSES = [
  { id: 'c1', title: 'Diversity & Inclusion', description: 'Promoting a respectful, inclusive, and equitable workplace culture.' },
  { id: 'c2', title: 'Safety Health and Environment (SHE)', description: 'Workplace safety, health standards, and environmental responsibility.' },
  { id: 'c3', title: 'Cyber and Information Security Awareness', description: 'Identifying cyber threats, phishing prevention, and data protection protocols.' },
  { id: 'c4', title: 'Data Privacy Awareness', description: 'GDPR compliance and secure handling of customer and company data.' },
  { id: 'c5', title: 'Financial Crime', description: 'Recognizing and preventing financial misconduct, fraud, and money laundering.' },
  { id: 'c6', title: 'Code of Conduct', description: 'Ethical standards, professional behavior, and corporate governance.' },
  { id: 'c7', title: 'Learn Upon', description: 'Platform orientation and core learning management system requirements.' },
  { id: 'c8', title: 'Shape DSE', description: 'Display screen equipment safety and ergonomic workstation setup.' }
];

export const ASSESSMENT_MODULES = [
  { key: 'communication', label: 'Communication & Tone' },
  { key: 'technicalSystem', label: 'Technical Systems (Temetra/SAP)' },
  { key: 'proceduralKnowledge', label: 'Procedural Knowledge' },
  { key: 'mockCalls', label: 'Mock Calls Simulation' },
];

export function trainingDates(startDateStr: string) {
  const dates = [];
  let currentDate = new Date(startDateStr);
  
  // Generate 18 working days (15 training days + 3 hypercare days)
  while (dates.length < 18) {
    const dayOfWeek = currentDate.getDay();
    // Skip weekends (0 = Sunday, 6 = Saturday)
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      const isHypercare = dates.length >= 15;
      dates.push({
        date: currentDate.toISOString().slice(0, 10),
        label: isHypercare ? `Hypercare ${dates.length - 14}` : `Day ${dates.length + 1}`
      });
    }
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dates;
}
